import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { CardsContainer } from "./CardsContainer";
import { PotContainer } from "./PotContainer";

export class TableContainer extends Phaser.GameObjects.Container {

    private static DEALER_CHIP_POSITIONS = [
        {x: 80, y: 420},
        {x: -220, y: 340},
        {x: -205, y: 200},
        {x: -100, y: 220},
        {x: 205, y: 200},
        {x: 220, y: 340}
    ];

    private potContainer: PotContainer;
    private dealerChip: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;

        this.scaleX = GameVars.scaleX;

        this.potContainer = new PotContainer(this.scene);
        this.add(this.potContainer);

        this.dealerChip = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "chip_dealer.png");
        this.dealerChip.visible = false;
        this.add(this.dealerChip);
    }

    public setDealer(tablePoisition: number): void {

        if (this.dealerChip.visible) {
            this.scene.tweens.add({
                targets: this.dealerChip,
                x: TableContainer.DEALER_CHIP_POSITIONS[tablePoisition].x,
                y: TableContainer.DEALER_CHIP_POSITIONS[tablePoisition].y,
                ease: Phaser.Math.Easing.Quadratic.Out,
                duration: 250 / GameVars.gameSpeed,
                onCompleteScope: this
            });
        } else {
            this.dealerChip.visible = true;
            this.dealerChip.alpha = 0;
            this.dealerChip.setPosition(TableContainer.DEALER_CHIP_POSITIONS[tablePoisition].x, TableContainer.DEALER_CHIP_POSITIONS[tablePoisition].y);
            this.scene.tweens.add({
                targets: this.dealerChip,
                alpha: 1,
                ease: Phaser.Math.Easing.Quadratic.In,
                duration: 150 / GameVars.gameSpeed,
                onCompleteScope: this
            });
        }
    }

    public updatePot(): void {

        this.potContainer.updatePot();
    }

    public hidePot(): void {

        this.potContainer.hidePot();
    }

    public resetTable(): void {

        this.scene.tweens.add({
            targets: this.potContainer,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250 / GameVars.gameSpeed,
            onComplete: () => {
                this.potContainer.visible = false;
            },
            onCompleteScope: this
        });
    }
}
